import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';
import ModalWrapper from '../../components/Modal/ModalWrapper';
import { Button, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { history } from '../../routers/AppRouter';
import PropTypes from 'prop-types';

const propTypes = {
  prevent: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  buttonConfirm: PropTypes.string,
  buttonLeavePage: PropTypes.string,
  onConfirm: PropTypes.func,
  children: PropTypes.node
};

const defaultProps = {
  title: 'Leave Page',
  message: 'Are you sure?',
  buttonConfirm: 'Confirm',
  buttonLeavePage: 'Leave Page',
  onConfirm: undefined
};

const PreventPageLeave = props => {
  const {
    prevent,
    title,
    message,
    buttonConfirm,
    buttonLeavePage,
    onConfirm,
    children
  } = props;
  const [active, setActive] = useState(false);
  const [desiredLocation, setDesiredLocation] = useState();

  // Add onbeforeunload Event listener to the page
  useEffect(() => {
    if (!prevent) return;

    window.onbeforeunload = event => {
      event.preventDefault();
      event.returnValue = '';
    };

    return () => {
      window.onbeforeunload = undefined;
    };
  }, [prevent]);

  const onConfirmClick = () => {
    if (onConfirm === undefined) {
      // Stay on this page and close modal
      setActive(false);
    } else {
      // Execute function and forward client path
      onConfirm(desiredLocation);
    }
  };

  const onLeavePageClick = () => {
    history.push(desiredLocation);
  };

  return (
    <React.Fragment>
      <Prompt
        when={prevent}
        message={location => {
          if (location.pathname === desiredLocation && active) {
            return true;
          }

          setActive(true);
          setDesiredLocation(location.pathname);

          return false;
        }}
      />
      {children}
      <ModalWrapper isOpen={active} modalClass="warning">
        <ModalHeader>{title}</ModalHeader>
        <ModalBody>
          <p>{message}</p>
        </ModalBody>
        <ModalFooter>
          <Button color="orange" onClick={onConfirmClick}>
            <i className="far fa-check" /> {buttonConfirm}
          </Button>
          <Button color="secondary" onClick={onLeavePageClick}>
            <i className="far fa-times-circle" /> {buttonLeavePage}
          </Button>
        </ModalFooter>
      </ModalWrapper>
    </React.Fragment>
  );
};

PreventPageLeave.propTypes = propTypes;
PreventPageLeave.defaultProps = defaultProps;
export default PreventPageLeave;
